import { Card, Image, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { CHART_HEIGHT } from "../ChartConstants";

export const PageEmptyState = () => {
  const i18n = useI18n();

  return (
    <Card mixin={{ paddingBlockStart: 6, paddingInlineStart: 6 }}>
      <Stack alignItems="center" justifyContent="center" mixin={{ height: `${CHART_HEIGHT}px` }}>
        <Stack direction="column" alignItems="center" gap={4}>
          <Image
            asset={{
              setName: "illustrations-partner-thumbnails",
              assetName: "RegistrationReviewRejected",
            }}
            width={80}
          />
          <Stack direction="column" alignItems="center" gap={1}>
            <Text variant="strong_1">
              {i18n.trans(t("flights_airline_portal_airline_view_realtime_error_all_header"))}
            </Text>
            <Text variant="body_2" attributes={{ style: { textAlign: "center", maxWidth: "500px" } }}>
              {i18n.trans(t("flights_airline_portal_airline_view_realtime_error_all_body"))}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
